/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as e, isNone as r } from "../../core/maybe.js";
import { replace as i } from "../../core/string.js";
import n from "./WKIDUnitConversion.js";
var a = {
  102113: !0,
  102100: !0,
  3857: !0,
  3785: !0
},
    _ = {
  102113: !0,
  102100: !0,
  3857: !0,
  3785: !0,
  4326: !0
},
    t = 'PROJCS["WGS_1984_Web_Mercator_Auxiliary_Sphere",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Mercator_Auxiliary_Sphere"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",{Central_Meridian}],PARAMETER["Standard_Parallel_1",0.0],PARAMETER["Auxiliary_Sphere_Type",0.0],UNIT["Meter",1.0]]',
    l = [-20037508.342788905, 20037508.342788905],
    M = [-20037508.342787, 20037508.342787],
    d = {
  102113: {
    wkTemplate: 'PROJCS["WGS_1984_Web_Mercator",GEOGCS["GCS_WGS_1984_Major_Auxiliary_Sphere",DATUM["D_WGS_1984_Major_Auxiliary_Sphere",SPHEROID["WGS_1984_Major_Auxiliary_Sphere",6378137.0,0.0]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Mercator"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",{Central_Meridian}],PARAMETER["Standard_Parallel_1",0.0],UNIT["Meter",1.0]]',
    valid: l,
    origin: M,
    dx: 1e-5
  },
  102100: {
    wkTemplate: t,
    valid: l,
    origin: M,
    dx: 1e-5
  },
  3785: {
    wkTemplate: 'PROJCS["WGS_1984_Web_Mercator",GEOGCS["GCS_WGS_1984_Major_Auxiliary_Sphere",DATUM["D_WGS_1984_Major_Auxiliary_Sphere",SPHEROID["WGS_1984_Major_Auxiliary_Sphere",6378137.0,0.0]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Mercator"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",{Central_Meridian}],PARAMETER["Standard_Parallel_1",0.0],UNIT["Meter",1.0]]',
    valid: l,
    origin: M,
    dx: 1e-5
  },
  3857: {
    wkTemplate: t,
    valid: l,
    origin: M,
    dx: 1e-5
  },
  4326: {
    wkTemplate: 'GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",{Central_Meridian}],UNIT["Degree",0.0174532925199433]]',
    altTemplate: 'PROJCS["WGS_1984_Plate_Carree",GEOGCS["GCS_WGS_1984",DATUM["D_WGS_1984",SPHEROID["WGS_1984",6378137.0,298.257223563]],PRIMEM["Greenwich",0.0],UNIT["Degree",0.0174532925199433]],PROJECTION["Plate_Carree"],PARAMETER["False_Easting",0.0],PARAMETER["False_Northing",0.0],PARAMETER["Central_Meridian",{Central_Meridian}],UNIT["Degrees",111319.491]]',
    valid: [-180, 180],
    origin: [-180, 90],
    dx: 1e-5
  },
  104971: {
    wkTemplate: 'GEOGCS["Mars_2000_(Sphere)",DATUM["Mars_2000_(Sphere)",SPHEROID["Mars_2000_(Sphere)",3396190.0,0.0]],PRIMEM["Reference_Meridian",0.0],UNIT["Degree",0.0174532925199433]]',
    valid: [-180, 180],
    origin: [-180, 90],
    dx: 1e-5
  },
  104905: {
    wkTemplate: 'GEOGCS["GCS_Mars_2000",DATUM["D_Mars_2000",SPHEROID["Mars_2000_IAU_IAG",3396190.0,169.8944472236118]],PRIMEM["Reference_Meridian",0.0],UNIT["Degree",0.0174532925199433]]',
    valid: [-180, 180],
    origin: [-180, 90],
    dx: 1e-5
  }
};

function E(e, i) {
  return !r(e) && !r(i) && (e === i || (null != e.wkid || null != i.wkid ? e.wkid === i.wkid || T(e) && T(i) || null != i.latestWkid && e.wkid === i.latestWkid || null != e.latestWkid && i.wkid === e.latestWkid : !(!e.wkt || !i.wkt) && e.wkt.toUpperCase() === i.wkt.toUpperCase()));
}

function S(e) {
  return I(e) && e.wkid ? d[e.wkid] : null;
}

function R(e) {
  return !!I(e) && (e.wkid ? null == n[e.wkid] : !!e.wkt && !!/^\s*GEOGCS/i.test(e.wkt));
}

function o(e) {
  return !(G(e) || C(e));
}

function A(e) {
  return I(e) && 4326 === e.wkid;
}

function u(e) {
  return I(e) && 4490 === e.wkid;
}

function T(e) {
  return I(e) && null != e.wkid && !0 === a[e.wkid];
}

function k(e) {
  return I(e) && 32662 === e.wkid;
}

function w(e) {
  return 104971 === e || 104905 === e;
}

function G(e) {
  return I(e) && null != e.wkid && w(e.wkid);
}

function P(e) {
  return 104903 === e;
}

function C(e) {
  return I(e) && null != e.wkid && P(e.wkid);
}

function s(e) {
  return I(e) && null != e.wkid && !0 === _[e.wkid];
}

function I(r) {
  return e(r) && (null != r.wkid && r.wkid >= 2e3 || null != r.wkt);
}

var c = {
  wkid: 4326,
  wkt: i(d[4326].wkTemplate, {
    Central_Meridian: "0.0"
  })
},
    p = {
  wkid: 102100,
  latestWkid: 3857
},
    D = {
  wkid: 32662
};
export { D as PlateCarree, c as WGS84, p as WebMercator, E as equals, S as getInfo, u as isCGCS2000, o as isEarth, R as isGeographic, G as isMars, C as isMoon, k as isPlateCarree, I as isValid, A as isWGS84, w as isWKIDFromMars, P as isWKIDFromMoon, T as isWebMercator, s as isWrappable };